<template lang="html">
  <footer class="wrap">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div>MediPay System 2017 - &copy; All rights reserved.</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footline'
}
</script>



// WEBPACK FOOTER //
// Footline.vue?82bf8440